import { useQuery } from '@tanstack/react-query'
import { getAllOffersFromRecruiter } from '../../../services/Recruiter/Dashboard'
import { useState } from 'react'
import { ListOfJobOffersSkeleton } from '../../../skeleton/Global/JobOffers/ListOfJobOffersSkeleton'
import DashboardWrapper from '../components/DashboardWrapper'
import useResize from '../../../hooks/useResize'
import { ITEMS_PER_PAGE, VIEWPORT_LG } from '../../../utils/constants'
import Divider from '../../../components/Divider'
import JobOfferCard from '../../JobOffers/components/JobOfferCard'
import Pagination from '../../../components/Pagination'

const ListFastOffersHutritNext = () => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const [page, setPage] = useState(0)

  const {
    data: allOffersFromRecruiterData,
    isInitialLoading: isLoadingAllOffersFromRecruiter,
  } = useQuery(['list-offers-hutrit-next', page], () =>
    getAllOffersFromRecruiter({ page, hutritNextPublic: true, isJunior: true })
  )

  return (
    <DashboardWrapper
      showTitle
      title={
        <div className="d-flex align-items-center gap-3">
          OFERTAS RAPIDAS HUTRIT NEXT
        </div>
      }
    >
      <Divider className="w-100 bg-on-bg-Tertiary" />
      <div
        className={`${
          isMobile ? 'w-100 p-2' : 'talent-asociate-tm-container'
        } mt-5`}
      >
        {isLoadingAllOffersFromRecruiter ? (
          <ListOfJobOffersSkeleton count={6} />
        ) : (
          allOffersFromRecruiterData?.offers?.map((props, index) => (
            <div key={index}>
              <JobOfferCard isFastofferHutritNext vacanciesTm {...props} />
            </div>
          ))
        )}
      </div>
      <div className="overflow-auto">
        <Pagination
          page={page}
          setPage={setPage}
          totalItems={allOffersFromRecruiterData?.countOffers}
          itemsPerPage={ITEMS_PER_PAGE}
          isGlobalState
        />
      </div>
    </DashboardWrapper>
  )
}

export default ListFastOffersHutritNext
